import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import PageContentPanel from 'components/v2/page-content-panel';
import PaxAccountContent from './pax-account-content';
import EnterpriseAccountContent from './enterprise-account-content';

const localeKeyPrefix = 'shopify.settings.manageEmployeeSection';

const ShopManageEmployeeSection = ({ isPaxAccount }) => (
  <PageContentPanel
    header={I18n.t(`${localeKeyPrefix}.header`)}
    message={I18n.t(`${localeKeyPrefix}.message`)}
  >
    {isPaxAccount ? <PaxAccountContent /> : <EnterpriseAccountContent />}
  </PageContentPanel>
);

ShopManageEmployeeSection.propTypes = {
  isPaxAccount: PropTypes.bool.isRequired,
};

export default ShopManageEmployeeSection;
